import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "@/store/store";
import {
  fetchPostingByIdThunk,
  type PostingDetail,
} from "./postingDetailOperations";

type PostingDetailState = Partial<PostingDetail> & {
  isLoading: boolean;
};

const initialState: PostingDetailState = {
  isLoading: false,
};

const slice = createSlice({
  name: "currentPosting",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPostingByIdThunk.pending, () => ({ isLoading: true }));
    builder.addCase(fetchPostingByIdThunk.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    });
  },
});

const selectSelf = (state: RootState) => state.postings.postingDetail;
const selectPostingDetail = (state: RootState) => selectSelf(state);

export const postingDetailSelectors = { selectPostingDetail };

export const reducer = slice.reducer;
